export namespace AppConstants {
  export var AppKey = "TheApp";
  export var Title = "App";
  export var SubTitle = "SubApp";
  export var Version = "1.0.0";

  export var Http = {
    CommonBaseUrl: window["appSettings"].CommonBaseUrl,
    BaseUrl: window["appSettings"].BaseUrl,
    BaseODataUrl: window["appSettings"].BaseODataUrl,
    Headers: {},
    AuthorizationHeader: false,
  };

  export var Lang = {
    current: window["appSettings"].Lang,
  };

  export var CustomerCode = window["appSettings"].customerCode;

  export var IsKioskMode = window["appSettings"].isKioskMode;

  export class Routes {
    public static Login = "Login";
    public static LoginByAccessTokenPage = "LoginByAccessTokenPage";
    public static PunchInOut = "Punch_In_Out";
    public static M_Employees = "M_Employees";
    public static M_Employee_Details = "M_Employee_Details";
    public static M_PersonalArea = "M_PersonalArea";
    public static E_PersonalArea = "E_PersonalArea";
    public static R_AttendReport = "R_AttendReport";
    public static M_TeamLeader = "M_TeamLeader";

  }

  export class UserRoles {
    public static Manager = "MANAGER";
    public static Employee = "EMPLOYEE";
  }

  export class EntryExitLogStates {
    //הגיע מהשעון אי אפשר לערוך
    public static Lock = "LOCK";
    //לבדוק ש IsManaual, מחכה לאישור מהמנהל - להציג סימן שאלה
    public static To_Approve = "TO_APPROVE";
    //אושר להציג עיגול V ירוק
    public static Approved = "APPROVED";
    public static Rejected = "REJECTED";
  }

  export class ReportCodes {
    public static Attend_Daily = "ATTEND_DAILY";
    public static Attend_Detail = "ATTEND_DETAIL";
    public static Attend_Sum = "ATTEND_SUM";
    public static Attend_Exceptions = "ATTEND_EXCEPTIONS";
    public static Sub_Attend_MissingEvents = "SUB_ATTEND_MISSINGEVENTS";
    public static Attend_Tamat = "ATTEND_TAMAT";
    public static Attend_Events = "ATTEND_EVENTS";
    public static Attend_Health_Declaration = "ATTEND_HEALTH_DECLARATION";
  }

  export class StoreActions {
    public static GetEmployeeMonthAttendViewData =
      "getEmployeeMonthAttendViewData";
    public static GetEmployeeMonthAttendEditData =
      "getEmployeeMonthAttendEditData";
    public static GetBaseItem = "getBaseItem";
    public static ReduceApprovalsCount = "reduceApprovalsCount";
    public static GetEmployeePortalMin = "getEmployeePortalMin";
    public static GetEmployeeStandByEditData = "getEmployeeStandByEditData";
  }

  export class StoreMutations {
    public static UpdateEmployeesList = "updateEmployeesList";
    public static UpdateCurrentEmployee = "updateCurrentEmployee";
    public static UpdateCurrentSelectedEmployees =
      "updateCurrentSelectedEmployees";
    public static UpdateEmployeeAttendViewData = "updateEmployeeAttendViewData";
    public static UpdateEmployeeAttendEditData = "updateEmployeeAttendEditData";
    public static UpdateIsLeftDrawerOpen = "updateIsLeftDrawerOpen";
    public static UpdateLeftDrawerComponnent = "updateLeftDrawerComponnent";
    public static UpdateBaseItems = "updateBaseItems";
    public static UpdateDrawerParams = "updateDrawerParams";
    public static UpdateHasApprovlas = "updateHasApprovlas";
    public static UpdateNoOfApprovals = "updateNoOfApprovals";
    public static UpdateSelectedMonth = "updateSelectedMonth";
    public static UpdateSelectedYear = "updateSelectedYear";
    public static UpdateActingManagers = "updateActingManagers";
    public static UpdateActingManagerId = "updateActingManagerId";
    public static updatePreviousEmployeeIds = "updatePreviousEmployeeIds";
    public static UpdateCurrentActingEmployeeId = "updateCurrentActingEmployeeId";
    public static UpdateSelectedEmpAdditionalJobId = "updateSelectedEmpAdditionalJobId";
    public static UpdateEmployeeAdditionalJobs = "updateEmployeeAdditionalJobs";
    public static UpdateEmployeeAdditionalJobKey = "updateEmployeeAdditionalJobKey";
    public static UpdateCanEditMonth = "updateCanEditMonth";
    public static UpdateSelectedEmpNominationId = "updateSelectedEmpNominationId";
    public static UpdateEmployeeStandByEditData = "updateEmployeeStandByEditData";
  }

  export class HttpMethods {
    public static Get = "GET";
    public static Post = "POST";
    public static Put = "PUT";
    public static Delete = "Delete";
  }

  export class ResponseTypes {
    public static Json = "json";
    public static Blob = "blob";
  }

  export class Entites {
    public static MissingEventSingleReport = "MissingEventSingleReportDto";
    public static MissingEventMulitpleReport = "MissingEventMulitpleReportDto";
    public static EmployeeStandby = "EmployeeStandbyDto";
  }

  export class EntityType {
    public static Employee = "Employee";
  }

  export class AttendEntrySource {
    public static Clock = "CLOCK";
    public static Application = "APPLICATION";
    public static Mobile = "MOBILE";
    public static External = "EXTERNAL";
    public static Portal = "PORTAL";
  }

  export class BaseItems {
    public static BreakType = "BreakType";
    public static HourType = "HourType";
    public static EmpAdditionType = "EmpAdditionType";
    public static EmployeeDayAdditionalReason = "EmployeeDayAdditionalReason";
    public static ReportLayout = "ReportLayout";
    public static SalaryFieldCategory = "SalaryFieldCategory";
    public static AccountingExportType = "AccountingExportType";
    public static DayType = "DayType";
    public static ActionCodeType = "ActionCodeType";
    public static MissingEvent = "MissingEvent";
    public static AttendSpecialEvent = "AttendSpecialEvent";
    public static NotSingingReason = "NotSingingReason";
  }

  export class EmpEmploymentType {
    public static Monthly = "MONTHLY";
    public static Hourly = "HOURLY";
  }

  export class DrawerComponnents {
    public static Reports = "Reports";
    public static ReportMissingEvent = "ReportMissingEvent";
    public static EmployeeAttendDayApprove = "EmployeeAttendDayApprove";
    public static EmployeeAttendMonthApprove = "EmployeeAttendMonthApprove";
    public static EmployeeAttendEditMobile = "EmployeeAttendEditMobile";
    public static EmployeeApprovalsFiles = "EmployeeApprovalsFiles";
    public static ApprovalsList = "ApprovalsList";
    public static ApprovalInfo = "ApprovalInfo";
    public static EmployeeSummary = "EmployeeSummary";
    public static Additions = "Additions";
  }

  export class EmpAdditionTypeCodes {
    public static Time = "TIME";
    public static Money = "MONEY";
    public static Quantity = "QUANTITY";
    public static KM = "KM";
  }

  export class SourceCode {
    public static Application = "APPLICATION";
    public static Portal = "PORTAL";
  }

  export class AttendMonthCheckStateStatusCodes {
    public static checked = "CHECKED";
    public static moved_to_salary = "MOVED_TO_SALARY";
  }

  export enum AttendReportPrintDetailsSortOrFiltringFields {
    OrgStructName = 1,
    SalaryFactoryNo = 2,
    SalaryNo = 3,
  }

  export enum Permissions {
    Punch = "PUNCH",
    WriteLog = "WRITE_LOG",
    WriteEvent = "WRITE_EVENT",
    CanSeeReports = "CAN_SEE_REPORTS",
    AttendLocationMandatory = "ATTEND_LOCATION_MANDATORY",
    EmpAttendReadyOnly = "EMP_ATTEND_READONLY",
    AttendSpecialActivity = "ATTEND_SPECIAL_ACTIVITY",
    EventWithoutRemark = "EVENT_WITHOUT_REMARK",
    AttendWithoutRemark = "ATTEND_WITHOUT_REMARK",
    HealthDeclaration = "HEALTH_DECLARATION",
    AttendUpdateToApprove = "ATTEND_UPDATE_TO_APPROVE",
    PortalPunchInOutOnly = "PORTAL_PUNCH_IN_OUT_ONLY",
    PortalEmpSignOnAttendReportMandatory = "PORTAL_EMP_SIGN_ON_ATTEND_REPORT_MANDATORY",
    PortalMngrSignOnAttendReportMandatory = "PORTAL_MNGR_SIGN_ON_ATTEND_REPORT_MANDATORY",
    PortalMngrSignOnMultipleAttendReports = "PORTAL_MNGR_SIGN_ON_MULITPLE_ATTEND_REPORTS",
    PortalNotSignReasonMandatory = "PORTAL_NOT_SIGN_REASON_MANDATORY",
    IsIndirectManagerActiveInPortal = "isIndirectManagerActiveInPortal",
    PortalLimitViewAtAttendanceAndSummaries = "PORTAL_LIMIT_VIEW_AT_ATTENDANCE_AND_SUMMARIES",
    PortalLimitViewAtSummaries = "PORTAL_LIMIT_VIEW_AT_SUMMARIES",
    PortalUploadAttachment = "ATTEND_UPLOAD_ATTACHMENT",
    PunchSpecialEventActivity = "PUNCH_SPECIAL_EVENT_ACTIVITY",
    PortalEnableAddReason = "PORTAL_ENABLE_ADD_REASON",
    PortalManagerEditClockAppPhonesData = "PORTAL_MANAGER_EDIT_CLOCK_APP_PHONES_DATA",
    PortalEmployeeEditClockAppPhonesData = "PORTAL_EMPLOYEE_EDIT_CLOCK_APP_PHONES_DATA",
    PortalManagerEditOnlyComment = "PORTAL_MANAGER_EDIT_ONLY_COMMENT",
    PortalSignMngrAllowErrorsRecords  = "PORTAL_SIGN_MNGR_ALLOW_ERRORS_RECORDS"
  }
}
